<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@components/Button.svelte';
  import Avatar from '@components/Avatar.svelte';
  import { getCurrentUserStore } from '@stores/current_user';
  const dispatch = createEventDispatcher();

  let currentUser = getCurrentUserStore('default');
  export let mobile = false;
</script>

<style style="text/scss" lang="scss">
  @import '../../../vendor/design-system.scss';

  .intro-step-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  * :global(.avatar) {
    cursor: default !important;
  }

  .button-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ui-title {
    @include typeface-h3($font-weight-bold);
    color: $neutral-black;
    margin-bottom: 8px;
  }

  .ui-subtitle {
    color: $neutral-gray;
    max-width: 400px;
  }
</style>

<div class="intro-step-container">
  <Avatar
    mobile={mobile}
    width={160}
    src={currentUser.avatar_url}
    user={currentUser}
    showSpotlightIfApplicable={false}
    showSpotlightRingOnly={true} />

  <div>
    <div class="ui-title">Creator Spotlight</div>
    <div class="ui-subtitle">
      Stand out by sharing unique details about yourself, your personality, and your credibility with the community.
    </div>
  </div>

  <div class="button-container">
    <Button
      style="padding-left: 40px; padding-right: 40px; width: auto; margin: 0;"
      colorScheme="black"
      on:click={() => {
        dispatch('finished');
      }}
      text="Get Started" />
  </div>
</div>
